const LayoutTypes = {
  GRID: "GRID",
  LIST: "LIST"
};

export default LayoutTypes;